import { createApp } from 'vue'
import App from './App.vue'
import './app.scss'
import 'vue3-resize/dist/vue3-resize.css'
import Vue3Resize from 'vue3-resize'

createApp(App)
    .use(Vue3Resize)
    .mount('#app')
